import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "..";

type State = {
  utmParams?: Record<string, string>;
};

const initialState: State = {};

export const utmSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setUTMParams: (state, action) => {
      state.utmParams = action.payload;
    },
  },
});

export const { setUTMParams } = utmSlice.actions;

export default utmSlice.reducer;

export const selectUTMParams = (state: RootState) => state.utm.utmParams;
